import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, MapPinIcon, PhoneIcon, StarIcon } from 'lucide-react';
import { business, reviewSummary } from '../data/site';
const trustPoints = [`${reviewSummary.rating} average from ${reviewSummary.count} verified ${reviewSummary.source} reviews`, '1 year / 12,000 mile parts and labor warranty on the repairs we perform', 'FCA Chrysler, Dodge and Jeep factory trained', '55+ years of combined technician experience', 'Financing available through Snap Finance, Affirm, Klarna and Sunbit'];
export function TrustLocalBand() {
  return <section className="w-full bg-chalk py-14 lg:py-16" data-id="element-481" data-mp="26c9da35ig5xp">
      <div className="mx-auto grid max-w-shell grid-cols-[minmax(0,1fr)] gap-10 px-5 lg:grid-cols-[minmax(0,1fr)_minmax(0,340px)] lg:gap-16 lg:px-8" data-id="element-482" data-mp="26dst5sn98eyy">
        <div className="min-w-0" data-id="element-483" data-mp="1dun5yzywzri1">
          <h2 className="font-display text-[24px] font-extrabold leading-[1.1] tracking-[-0.02em] text-ink sm:text-[30px]" data-id="element-484" data-mp="1dtlvoxpq391d">
            Why drivers use East End Automotive
          </h2>
          <ul className="mt-6 grid grid-cols-[minmax(0,1fr)] gap-2.5 sm:grid-cols-2" data-id="element-485" data-mp="1jhmeel7tnlil">
            {trustPoints.map(point => <li key={point} className="flex min-w-0 items-start gap-2.5" data-id="element-486" data-mp="1oevz5nk9n903">
                <StarIcon className="mt-0.5 h-4 w-4 shrink-0 fill-brand text-brand" aria-hidden="true" data-id="element-487" data-mp="1t8qs7hlrh0bu" />
                <span className="text-[14.5px] leading-snug text-steel/80" data-id="element-488" data-mp="10jtdtpko7nod">
                  {point}
                </span>
              </li>)}
          </ul>
          <Link to="/the-east-end-way" className="mt-6 inline-block text-[12.5px] font-bold uppercase tracking-[0.08em] text-brand-dark hover:underline" data-id="element-489" data-mp="1ahh688ut0j3d">
            The East End Way
          </Link>
        </div>

        <dl className="min-w-0 rounded-lg border border-black/10 bg-white p-6" data-id="element-490" data-mp="2lvupf0em4ad2">
          <div className="flex gap-3" data-id="element-491" data-mp="2pxgbncd1e0zx">
            <MapPinIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-dark" aria-hidden="true" data-id="element-492" data-mp="2pwenq7ax9k0s" />
            <div data-id="element-493" data-mp="lun2kflywks7">
              <dt className="text-[12px] font-bold uppercase tracking-[0.12em] text-steel/50" data-id="element-494" data-mp="lv6ar4ltfut1">
                Location
              </dt>
              <dd className="mt-1 text-[15px] leading-snug text-steel/80" data-id="element-495" data-mp="ztcznv8sekgk">
                {business.address.street}, {business.address.city},{' '}
                {business.address.state} {business.address.zip}
              </dd>
            </div>
          </div>
          <div className="mt-5 flex gap-3" data-id="element-496" data-mp="34ombc80nldh">
            <ClockIcon className="mt-0.5 h-5 w-5 shrink-0 text-brand-dark" aria-hidden="true" data-id="element-497" data-mp="31smficlymme" />
            <div data-id="element-498" data-mp="c4ton7ycrtks">
              <dt className="text-[12px] font-bold uppercase tracking-[0.12em] text-steel/50" data-id="element-499" data-mp="c4bpo3kb3196">
                Hours
              </dt>
              <dd className="mt-1 space-y-0.5 text-[15px] text-steel/80" data-id="element-500" data-mp="3kikb8roeurru">
                {business.hours.map(h => <p key={h.days} data-id="element-501" data-mp="3fjfxdnqjk5v6">
                    <span className="text-steel/55" data-id="element-502" data-mp="1v2zq6jycaxlf">{h.days}:</span> {h.time}
                  </p>)}
              </dd>
            </div>
          </div>
          <a href={business.phoneHref} className="mt-6 flex w-full max-w-full items-center justify-center gap-2.5 rounded-md bg-brand px-3 py-3 text-center font-display text-[16px] font-bold text-white transition-colors duration-150 ease-out hover:bg-brand-light sm:inline-flex sm:w-auto sm:whitespace-nowrap sm:px-5" data-id="element-503" data-mp="1m2jsjr4a2koh">
            <PhoneIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-504" data-mp="2iriy2ydh98cz" />
            Call {business.phone}
          </a>
        </dl>
      </div>
    </section>;
}